function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import React from "react";

var _ref2 = React.createElement("path", {
  d: "M12 0.786133C18.1932 0.786364 23.2146 5.80686 23.2148 12C23.2146 18.1932 18.1932 23.2146 12 23.2148C5.80686 23.2146 0.786359 18.1932 0.786133 12C0.786359 5.80685 5.80685 0.786359 12 0.786133ZM12 2.78613C6.91142 2.78636 2.78636 6.91142 2.78613 12C2.78636 17.0886 6.91142 21.2146 12 21.2148C17.0886 21.2146 21.2146 17.0887 21.2148 12C21.2146 6.91142 17.0886 2.78636 12 2.78613ZM12 10.2148C12.5521 10.2151 13 10.6627 13 11.2148V15.7148H14.3574C14.9095 15.7151 15.3574 16.1627 15.3574 16.7148C15.3571 17.2667 14.9093 17.7146 14.3574 17.7148H9.64355C9.09146 17.7148 8.64386 17.2669 8.64355 16.7148C8.64355 16.1626 9.09127 15.7148 9.64355 15.7148H11V12.2148H10.4287C9.87674 12.2147 9.42901 11.7668 9.42871 11.2148C9.42871 10.6627 9.87655 10.215 10.4287 10.2148H12ZM12 5.89258C12.7691 5.89258 13.3923 6.51616 13.3926 7.28516C13.3926 8.05441 12.7692 8.67871 12 8.67871C11.965 8.67871 11.9305 8.67636 11.8965 8.67285C11.1757 8.61975 10.6074 8.01953 10.6074 7.28516C10.6077 6.51625 11.2311 5.89273 12 5.89258Z"
});

var SvgInfo = function SvgInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info.7932ca07.svg";
export { ForwardRef as ReactComponent };